"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Register class as custom element.
 */
function element(name, options, window) {
    // tslint:disable-next-line
    return function (target) {
        var ctor = target;
        var customElementsFunc = window ? window.customElements : customElements;
        if (!ctor.hasOwnProperty('tag')) {
            Object.defineProperty(ctor, 'tag', { value: name, writable: true });
        }
        if (customElementsFunc.get(name)) {
            console.warn("Element <" + name + "> has been already registered.");
        }
        else {
            customElementsFunc.define(name, ctor, options);
        }
        return ctor;
    };
}
exports.element = element;
